import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TrustResourceUrlPipe } from '@finder/shared/utils/pipes/trust-resource-url/trust-resource-url.pipe';
import { ComponentHeaderComponent } from '../component-header/component-header.component';

@Component({
    selector: 'finder-iframe',
    templateUrl: './iframe.component.html',
    styleUrls: ['./iframe.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TrustResourceUrlPipe,
        ComponentHeaderComponent,
    ]
})
export class IframeComponent {

    @Input() headerData: any;
    @Input() iframeData: any;

    constructor() { }
}
